import { FormControlLabel, Switch } from '@mui/material';

interface ShowInactiveToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export const ShowInactiveToggle: React.FC<ShowInactiveToggleProps> = ({ checked, onChange }) => (
  <FormControlLabel
    control={<Switch size='small' checked={checked} onChange={(e) => onChange(e.target.checked)} />}
    label='Mostrar inativos'
  />
);
